interface ProjectResponseProgressBarProps {
  progress: number;
}

export default function ProjectResponseProgressBar({
  progress,
}: ProjectResponseProgressBarProps) {
  const percent = Math.round(Math.min(Math.max(progress, 0), 1) * 100);
  return (
    <div
      data-test='project-response-progress-bar'
      className='flex w-full items-center justify-center rounded-sm'
    >
      <progress
        aria-label='Survey progress'
        value={percent}
        max={100}
        className='h-0.5 w-full appearance-none overflow-hidden rounded-sm bg-gray-100 [&::-moz-progress-bar]:rounded-sm [&::-moz-progress-bar]:bg-(--brand-primary) [&::-webkit-progress-bar]:bg-gray-100 [&::-webkit-progress-value]:rounded-sm [&::-webkit-progress-value]:bg-(--brand-primary) [&::-webkit-progress-value]:transition-[width] [&::-webkit-progress-value]:duration-300'
      />
    </div>
  );
}
